import { useContext } from 'react';
import { AppRoutesContext } from '../components';
export function useAppRoutes() {
    var appRoutes = useContext(AppRoutesContext);
    return appRoutes.filter(function (route) { var _a; return !((_a = route.path) === null || _a === void 0 ? void 0 : _a.includes(':')) && !route.index; });
}
